// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1vU_3","overflowing":"ReadFullNote_overflowing__2Nr1t"};